export class StringUtil {
    public static removeSpaces(value: string) {
        return value.replaceAll(' ', '');
    }
}
